import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, serviceActionTypes, serviceFieldsTypes, serviceInjectionTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupFields = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceFieldsTypes.FieldsLookupDataType): AxiosPromise<serviceFieldsTypes.FieldsLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.fields.lookupFields), {
      blockSpinner,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.fields.lookupFields), {
    blockSpinner,
  });
};
